/* eslint-disable no-param-reassign */
const APP = require('APP')
const $ = require('jquery')
const _ = require('underscore')

const router = require('router')
const killEvent = require('Helpers/killEvent')

// eslint-disable-next-line no-extend-native
String.prototype.fulltrim = function fulltrim() {
  return this.replace(/(?:(?:^|\n)\s+|\s+(?:$|\n))/g, '').replace(/\s+/g, ' ')
}
// eslint-disable-next-line no-extend-native
String.prototype.trim = function trim() {
  return this.replace(/^\s+|\s+$/g, '')
}
/*
 ** Returns the caret (cursor) position of the specified text field.
 ** Return value range is 0-oField.value.length.
 */
APP.doGetCaretPosition = function doGetCaretPosition(oField) {
  let iCaretPos = 0

  // IE Support
  if (document.selection) {
    // Set focus on the element
    oField.focus()

    // To get cursor position, get empty selection range
    const oSel = document.selection.createRange()

    // Move selection start to 0 position
    oSel.moveStart('character', -oField.value.length)

    // The caret position is selection length
    iCaretPos = oSel.text.length
  } else if (oField.selectionStart || oField.selectionStart === '0') {
    iCaretPos = oField.selectionStart
  }

  return iCaretPos
}

$.fn.replaceClass = function replaceClass(find, replace) {
  this[0].className = this[0].className.replace(find, replace)
}

$.fn.delayFn = function delayFn(fn, time) {
  // eslint-disable-next-line prefer-rest-params
  _.delay(this[fn].bind(this), time, arguments[2], arguments[3], arguments[4], arguments[5])
}

$.fn.badge = function badge(num) {
  if (num) {
    this.attr('data-badge', num)
  } else {
    this.removeAttr('data-badge')
  }
}

$.fn.click = function click(selector, funct) {
  if (typeof selector === 'function') {
    funct = selector
    selector = undefined
  }

  if (this[0] && funct) {
    if (window.MOBILE) {
      let ev

      const touchStartEvent = function touchStartEvent() {
        ev = [new Date().getTime(), this[0], 0]
      }

      const touchEndEvent = function touchEndEvent(e) {
        const d = new Date().getTime() - ev[0]
        // eslint-disable-next-line no-sequences
        if ((d < 500 && this[0] === ev[1], ev[2] < 5)) {
          funct.call(this, e)
        }
      }

      const touchMoveEvent = function touchMoveEvent() {
        ev[2]++
      }
      this.on('touchstart', selector, touchStartEvent)
      this.on('touchend', selector, touchEndEvent)
      this.on('click', selector, touchEndEvent)
      this.on('touchmove', selector, touchMoveEvent)
    } else {
      if (this.selector === '') {
        // console.log(this);
      }
      this.on('click', funct)
    }
  }
  return this
}

$.fn.pushUrl = function pushUrl() {
  const $this = $(this)
  if (this && this.length > 1) {
    this.each(() => {
      $(this).pushUrl()
    })
    return this
  }

  if (window.history.pushState) {
    $this.on('click', (e) => {
      if (!e.ctrlKey) {
        killEvent(e)
        router.redirect($this.attr('href'), true, $this.attr('title') || $this.text().trim())
      }
    })
  }

  return $this
}

/**
 * scale css
 */
$.fn.scale = function scale(innerScale) {
  // console.log(this);
  if (!innerScale) {
    return $(this).css('transform')
  }
  return $(this).css('transform', `scale(${innerScale})`)
}
/**
 * Setting cursor position in input;
 */
$.fn.fp = function fp() {
  const $this = this
  const focus = this.focus()
  if (focus && focus.setCursorPosition) {
    focus.setCursorPosition(999)
  }
  _.delay(() => {
    $this[0].focus()
  }, 200)
}

$.fn.setCursorPosition = function setCursorPosition(pos) {
  if (!this) {
    return null
  }

  const $this = $(this)
  const this0 = $this[0]
  if (!$this || !this0) {
    return $this
  }

  if (this0.setSelectionRange) {
    try {
      this0.setSelectionRange(pos, pos)
    } catch (err) {
      // console.error(err);
    }
  } else if (this0.createTextRange) {
    const range = this0.createTextRange()
    range.collapse(true)
    range.moveEnd('character', pos)
    range.moveStart('character', pos)
    range.select()
  }

  return $this
}

$.fn.addValidatorRules = function addValidatorRules(rules) {
  const form = $(this)
  let validator
  if (form.length && _.isObject(rules) && !_.isEmpty(rules)) {
    const namedRules = {}

    _.forEach(rules, (value, key) => {
      const elem = form.find(`#${key}`)
      if (elem.length) {
        namedRules[elem.prop('name')] = value
      }
    })

    validator = form.validate({
      rules: namedRules,

      errorPlacement(error, element) {
        let p = element.parent()
        let i = 5

        while (i--) {
          if (p.hasClass('item-container')) {
            i = 0
          } else {
            p = p.parent()
          }
        }

        error.appendTo(p)
      },
    })

    form.data('validator', validator)

    _.forEach(rules, (value, key) => {
      const elem = form.find(`#${key}`)

      if (elem.prop('nodeName') === 'FIELDSET') {
        // console.log(elem.prop('name'), value);
        const rls = {}
        rls[elem.prop('name')] = value
        form.validate({ rules: rls })
        // form.rules('add', rls);
      } else if (elem.length) {
        elem.rules('add', value)
      }
    })
  }
  return validator
}

$.fn.pushValidatorErrors = function pushValidatorErrors(errors, addMsg) {
  const $this = this
  const arr = []

  _.forEach(errors, (error, key) => {
    if (key === '_form') {
      if (_.isFunction(addMsg)) {
        addMsg(error)
      }
      return
    }

    const field = $this.find(`#${key}`)
    if (field && field.length) {
      arr[field.attr('name')] = error
    }
  })
  $this.validate().showErrors(arr)
}

module.exports = {}
